<template>
    <Layout sub="elo">
        <h1>Elo Report</h1>
    </Layout>
    <section class="flex flex-col">
        <!-- Report Menu -->
        <div class="flex flex-row justify-between items-center">
            <div></div>
            <div></div>
        </div>

        <!-- Filters -->
        <div class="flex">

        </div>

        <!-- Filtered Contents -->
        <div class="flex flex-row w-full">
            <!-- Left panel -->
            <div class="flex flex-col w-2/3">
                <h2>Count</h2>
                <h4>345</h4>
            </div>

            <!-- Right panel -->
            <div class="flex flex-col w-2/3">
                <h2>Display Type</h2>

            </div>
        </div>
    </section>
</template>

<script setup>
import Layout from "@/Shared/Layout"</script>
<script>
export default {
    layout: ''
}
</script>
